export const iconFontAwesomeBuildingsHouseCircleExclamation = (
	<i className="fa-solid fa-house-circle-exclamation"></i>
);
